<template lang="pug">
.program-items
  .program-item(v-for="(programItem, index) in programItems" :key="index")
    BriqInput(
      label="Duration (minutes)"
      v-model="programItem.duration"
      type="number"
      step="1"
      min="0"
      :class="shouldShowMultilanguage ? `hidden` : ``"
      )
    BriqInput(
      label="Program item title"
      v-model="programItem.title"
      )
    BriqInput(
      label="Program item subtitle"
      v-model="programItem.description"
      )
  .add-program-item-btn-holder(v-if="displayAddButton && !shouldShowMultilanguage")
    BriqButton.add-program-item-btn(@click="$emit('addProgramItem')" small) Add program item
</template>

<script>
import { flatten, values } from 'ramda'

export default {
  name: 'ProgramItems',
  props: {
    program: Object,
    shouldShowMultilanguage: Boolean,
  },
  computed: {
    programItems() {
      return flatten(values(this.program))
    },
    displayAddButton() {
      return this.program && this.programItems.length > 0
    },
  },
}
</script>

<style lang="stylus">
@import '~@v/variables.styl'

.program-item:not(:last-of-type)
  margin-bottom 40px

.add-program-item-btn-holder
  border-radius 2px
  background-color #f1f3f6
  border solid 1px #ebebeb
  padding 10px
  width 100%
  min-height 116px
  display flex
  align-items center
  justify-content center
  margin-bottom 40px

  .add-program-item-btn
    margin 0 auto
    display block

.program-items .briq-form-element
  margin-bottom space-S
</style>
